import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ACTIONS, COLUMNS, NEW_RULE_ID, TRANSLATION_KEY } from '../constants';
import { RuleShape } from '../propShapes';
import RuleNameCell from './RuleNameCell';
import css from '../style.css';

const SINGULAR_FAVICON = '/static/dashboard/img/favicon.ico';

const UpdatedByCell = ({ rule, translate }) => {
    if (rule.id === NEW_RULE_ID || (!rule.updated_by && !rule.generated && !rule.last_update_by_singular)) {
        return '';
    }
    const bySingular = rule.last_update_by_singular || rule.generated;
    const label = rule.generated
        ? translate(`${TRANSLATION_KEY}.AUTO_GENERATED`)
        : rule.last_update_by_singular
        ? translate(`${TRANSLATION_KEY}.SINGULAR`)
        : rule.updated_by;

    return (
        <span className={css.updatedBy}>
            {(bySingular || rule.picture) && (
                <img width="20" height="20" alt="" src={bySingular ? SINGULAR_FAVICON : rule.picture} />
            )}
            <span className={css.updatedByName}>{label}</span>
        </span>
    );
};

UpdatedByCell.propTypes = {
    rule: RuleShape.isRequired,
    translate: PropTypes.func.isRequired,
};

const StatusCell = ({ rule, translate }) => {
    if (rule.id === NEW_RULE_ID) return translate(`${TRANSLATION_KEY}.NEW`);
    return (
        <span className={css.status}>
            <b className={classNames(css.statusDot, rule.active ? css.green : css.red)}>●</b>{' '}
            {rule.active ? translate(`${TRANSLATION_KEY}.ACTIVE`) : translate(`${TRANSLATION_KEY}.PAUSED`)}
        </span>
    );
};

StatusCell.propTypes = {
    rule: RuleShape.isRequired,
    translate: PropTypes.func.isRequired,
};

const renderCell = (columnKey, rule, { editing, searchText, translate, editRule }) => {
    switch (columnKey) {
        case 'name':
            return <RuleNameCell rule={rule} editing={editing} searchText={searchText} editRule={editRule} />;
        case 'updatedBy':
            return <UpdatedByCell rule={rule} translate={translate} />;
        case 'lastUpdated':
            return rule.updated ? new Date(rule.updated * 1000).toLocaleDateString() : '';
        case 'action':
            return ACTIONS[rule.action] ? translate(ACTIONS[rule.action]) : '';
        case 'status':
            return <StatusCell rule={rule} translate={translate} />;
        default:
            return null;
    }
};

const RuleRow = ({ rule, editing, searchText, translate, editRule, onClick }) => (
    <tr className={classNames(css.ruleRow, { [css.editing]: editing })} onClick={onClick}>
        {COLUMNS.map(column => (
            <td key={column.key}>{renderCell(column.key, rule, { editing, searchText, translate, editRule })}</td>
        ))}
    </tr>
);

RuleRow.propTypes = {
    rule: RuleShape.isRequired,
    editing: PropTypes.bool,
    searchText: PropTypes.string,
    translate: PropTypes.func.isRequired,
    editRule: PropTypes.func.isRequired,
    onClick: PropTypes.func,
};

export default RuleRow;
